/**
 * COVELiFE - Variant Image Filter v4.6
 * Filters the product gallery to the selected variant's images, then hands
 * control back to the theme: no manual counter writes, no is-active/aria
 * churn. Dawn's slider-component recounts visible slides itself (initPages),
 * so we only toggle display and scroll via the slider's own positioning.
 *
 * Filter axis: Color if it has 2+ values, else Leather Patch, else show all.
 * Size is never a filter axis. Alt text convention: "... [Value] - [view]".
 */
(function () {
  'use strict';

  function getGroupByLabel(re) {
    var groups = document.querySelectorAll('.product-form__input');
    for (var i = 0; i < groups.length; i++) {
      var label = groups[i].querySelector('legend, .form__label, label');
      if (label && re.test(label.textContent)) return groups[i];
    }
    return null;
  }

  function selectedValueIfVaries(group) {
    if (!group) return null;
    var radios = group.querySelectorAll('input[type="radio"]');
    if (radios.length >= 2) {
      var checked = group.querySelector('input[type="radio"]:checked');
      return checked && checked.value ? checked.value.trim().toLowerCase() : null;
    }
    var sel = group.querySelector('select');
    if (sel) {
      var opts = sel.querySelectorAll('option');
      if (opts.length >= 2 && sel.value) return sel.value.trim().toLowerCase();
    }
    return null;
  }

  function getSelectedTerm() {
    var colorGroup = getGroupByLabel(/color/i);
    if (!colorGroup) {
      var groups = document.querySelectorAll('.product-form__input');
      for (var i = 0; i < groups.length; i++) {
        if ((groups[i].className || '').indexOf('swatch') !== -1) { colorGroup = groups[i]; break; }
      }
    }
    var c = selectedValueIfVaries(colorGroup);
    if (c) return c;
    var p = selectedValueIfVaries(getGroupByLabel(/patch/i));
    if (p) return p;
    return null;
  }

  function setDisplay(items, term) {
    var firstVisible = null;
    var visibleCount = 0;
    items.forEach(function (item) {
      var img = item.querySelector('img');
      var match = !term || !img || !img.alt || img.alt.toLowerCase().indexOf(term) !== -1;
      item.style.display = match ? '' : 'none';
      if (match) { visibleCount++; if (!firstVisible) firstVisible = item; }
    });
    return { firstVisible: firstVisible, visibleCount: visibleCount };
  }

  function refreshSlider(el) {
    var sc = el && el.closest('slider-component');
    if (sc && typeof sc.initPages === 'function') sc.initPages();
    return sc;
  }

  var lastTerm;
  var domSwapped = true;
  function runFilter() {
    var term = getSelectedTerm();
    var shouldScroll = domSwapped || term !== lastTerm;
    lastTerm = term;
    domSwapped = false;
    var slides = Array.prototype.slice.call(document.querySelectorAll('.product__media-item'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.thumbnail-list__item'));
    if (!slides.length) return;

    var slideResult = setDisplay(slides, term);
    if (term && slideResult.visibleCount === 0) {
      setDisplay(slides, null);
      setDisplay(thumbs, null);
      refreshSlider(slides[0]);
      if (thumbs[0]) refreshSlider(thumbs[0]);
      return;
    }
    setDisplay(thumbs, term);

    var sc = refreshSlider(slides[0]);
    if (thumbs[0]) refreshSlider(thumbs[0]);
    wireMainArrows();

    if (shouldScroll && sc) {
      var slider = sc.querySelector('.slider');
      if (slider) slider.scrollTo({ left: 0, behavior: 'instant' });
    }

    var heroImg = slideResult.firstVisible && slideResult.firstVisible.querySelector('img');
    if (heroImg && !heroImg.complete) heroImg.loading = 'eager';
  }

  // Idle-warm gallery images so reveals paint from cache. Desktop's thumbnail
  // layout keeps non-active slides display:none, so EVERY slide first shown
  // pops in unless warmed - warm them all there. Mobile warms only each
  // color's first slide (the variant-switch landing image); the rest lazy-load
  // into ratio-reserved boxes as the slider reaches them.
  // Other variants' featured images are EXCLUDED from the gallery DOM by the
  // theme's hide-variants logic until selected, so a color switch fetches its
  // landing image from zero. Warm them from the public product JSON, at the
  // widths the desktop (493 @1x) and retina (990 @2x) slides request.
  function warmVariantFeatured() {
    fetch(window.location.pathname + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var seen = {};
      (p.variants || []).forEach(function (v) {
        var u = v.featured_image && v.featured_image.src;
        if (!u || seen[u]) return;
        seen[u] = true;
        [493, 990].forEach(function (w) {
          var img = new Image();
          img.src = u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
        });
      });
    }).catch(function () {});
  }

  function warmImages() {
    warmVariantFeatured();
    var desktop = window.matchMedia('(min-width: 990px)').matches;
    var seen = {};
    document.querySelectorAll('.product__media-item img').forEach(function (img) {
      if (img.complete) return;
      if (!desktop) {
        if (!img.alt) return;
        var left = img.alt.split(' - ')[0];
        if (seen[left]) return;
        seen[left] = true;
      }
      var warm = new Image();
      if (img.sizes) warm.sizes = img.sizes;
      if (img.srcset) warm.srcset = img.srcset;
      warm.src = img.src;
    });
  }

  // Desktop shows only the is-active slide (non-active are display:none), so
  // the main slider is unscrollable and Dawn's scroll-paging arrows no-op.
  // Route those clicks through the theme's own activation path instead,
  // cycling within the currently filtered slides. Mobile stays native.
  function wireMainArrows() {
    var mg = document.querySelector('media-gallery');
    var sc = mg && mg.querySelector('slider-component:not(.thumbnail-slider)');
    if (!sc || sc.dataset.covelifeArrows) return;
    sc.dataset.covelifeArrows = '1';
    sc.addEventListener('click', function (e) {
      var btn = e.target.closest('button[name="next"], button[name="previous"]');
      if (!btn) return;
      var slider = sc.querySelector('.slider');
      if (slider && slider.scrollWidth > slider.clientWidth + 10) return;
      var candidates = Array.prototype.slice.call(document.querySelectorAll('.product__media-item'))
        .filter(function (s) { return s.style.display !== 'none'; });
      if (candidates.length < 2) return;
      var current = candidates.findIndex(function (s) { return s.classList.contains('is-active'); });
      var dir = btn.getAttribute('name') === 'next' ? 1 : -1;
      var target = candidates[(current + dir + candidates.length) % candidates.length];
      var mediaId = target.getAttribute('data-media-id');
      if (mg && typeof mg.setActiveMedia === 'function' && mediaId) {
        mg.setActiveMedia(mediaId, false);
      } else {
        var thumb = mediaId && document.querySelector('.thumbnail[data-target="' + mediaId + '"]');
        if (thumb) thumb.click();
      }
    });
  }

  var queued = null;
  function queueFilter(delay) {
    if (queued) clearTimeout(queued);
    queued = setTimeout(function () { queued = null; runFilter(); }, delay || 60);
  }

  function init() {
    queueFilter(150);
    window.addEventListener('load', function () {
      queueFilter(50);
      setTimeout(warmImages, 1200);
    });

    // Deliberately NO option-change listener: filtering the outgoing DOM hides
    // the still-displayed active slide and collapses the gallery for the
    // ~150ms until the theme's section re-render lands (thumbnails jump up,
    // content shoves back down). The old image must hold until the observer
    // sees the replacement DOM arrive.

    var gallery = document.querySelector('media-gallery, .product__media-wrapper');
    if (gallery) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var nodes = Array.prototype.slice.call(muts[i].addedNodes)
            .concat(Array.prototype.slice.call(muts[i].removedNodes));
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            var isMedia = (n.matches && n.matches('.product__media-item, .thumbnail-list__item, .product__media-list, .thumbnail-list')) ||
              (n.querySelector && n.querySelector('.product__media-item, .thumbnail-list__item'));
            if (isMedia) { domSwapped = true; queueFilter(30); return; }
          }
        }
      }).observe(gallery, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
